module.exports = {
  firebaseConfig: {
    apiKey: "AIzaSyBi1DFJlBr9Cezf2BwfaT-PRPYmi3X3pdA",
    authDomain: "elife-prod.firebaseapp.com",
    databaseURL: "https://elife-prod.firebaseio.com",
    projectId: "firebase-elife-prod",
    appId: "1:220595262805:web:99ec0e25b6524ae7a98bdc",
    storageBucket: "firebase-elife-prod.appspot.com",
    messagingSenderId: "220595262805",
  },

  cloudFunctionsBasePath:
    "https://us-central1-firebase-elife-prod.cloudfunctions.net",
  warmUpApiUrl: "https://ufh.v1.rointe.io",
};
